export const clusterTable = {
    title: 'クラスタ一覧',
    userInputLabel: 'クラスタの絞り込み',
    userInputPlaceholder: 'キーワードを入力してください',
    userInputExample: '入力例 アンモニア、化学繊維など',
    searchTarget: '検索対象',
    clusterName: 'クラスタ名',
    ipcLabel: '技術分類（IPC）ラベル',
    inventionTitle: '発明の名称',
    publicationNumber: '公開番号/特許番号',
    searchOption: '検索オプション',
    ipcCodeLabel: '技術分類（IPC）コード',
    ipcCodePlaceholder: '入力してください',
    searchButton: '絞り込みする',
    countText: '該当クラスタ：',
    countNumber: '件',
    singleSort: '※項目をクリックすると単項目で並べ替えができます。',
    column1: 'クラスタID',
    column2: 'クラスタ名',
    column3: '領域',
    column4: 'スコア',
    column5: 'スコア成長率',
    column6: '市場期待値 [百万円]',
    column7: '市場期待値成長率',
    column8: 'スタートアップ市場期待値 [百万円]',
    column9: 'スタートアップ市場期待値成長率',

    csvColumn1: 'クラスタID',
    csvColumn2: 'クラスタ名',
    csvColumn3: '領域',
    csvColumn4: 'スコア',
    csvColumn5: 'スコア成長率',
    csvColumn6: '市場期待値 [百万円]',
    csvColumn7: '市場期待値成長率',
    csvColumn8: 'スタートアップ市場期待値 [百万円]',
    csvColumn9: 'スタートアップ市場期待値成長率',
    csvColumn10: 'ビジネス規模',
    csvColumn11: '特許出願数',
    csvColumn12: '特許被引用数'
}
